module.exports = __webpack_public_path__ + "img/chevronRight.1d67e596.svg";